<template>
  <v-container>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{$t("general")}}</v-tab>
      <v-tab v-if="value.type == 'Combo'" key="Combo">Combo</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-form ref="form" v-model="valid">
            <v-select
              :label="$t('entities.entityFieldCustom.props.entity')"
              item-text="value"
              item-value="value"
              :items="$entityName"
              v-model="value.entity"
              clearable
              :rules="$isRequiredRule"
            ></v-select>
            <v-select
              :label="$t('entities.entityFieldCustom.props.type')"
              v-model="value.type"
              item-text="value"
              item-value="value"
              :items="$fieldCustomType"
              clearable
              :rules="$isRequiredRule"
            ></v-select>
            <v-text-field
              :label="$t('entities.entityFieldCustom.props.label')"
              v-model="value.label"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
            <v-text-field
              :label="$t('entities.entityFieldCustom.props.seq')"
              v-model="value.seq"
              clearable
            ></v-text-field>
            <v-text-field
              :label="$t('entities.entityFieldCustom.props.group')"
              v-model="value.group"
              clearable
            ></v-text-field>
          </v-form>
        </v-tab-item>
        <v-tab-item key="Combo">
          <entity-field-custom-combo v-model="value.comboValues"></entity-field-custom-combo>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>
<script>
import entityFieldCustomCombo from "./entityFieldCustomCombo";
export default {
  props: {
    value: {
      default() {
        return {
          type: "",
          entity: "",
          group: "",
          label: "",
          comboValues: [],
        };
      },
    },
  },
  components: { entityFieldCustomCombo },
  data() {
    return {
      tab: null,
      valid: false,
    };
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
    },
  },
  methods: {
    isValid() {
      return this.$refs.form.validate();
    },
  },
};
</script>